import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { PanelComponent } from '../core/panels/panel.component';
import { EulaVerificationComponent } from '../layout/eula-verification.component';
@Component({
  selector: 'app-page-layout',
  imports: [RouterOutlet, PanelComponent, EulaVerificationComponent],
  template: `
    <div class="tw-w-full tw-max-w-[1300px]">
      <div class="tw-w-full tw-px-2 sm:tw-px-8 tw-pt-4">
        <app-panel>
          <ng-template #header> </ng-template>
          <router-outlet></router-outlet>
          <app-eula-verification />
        </app-panel>
      </div>
    </div>
  `,
  styles: ``,
})
export class PageLayoutComponent extends BaseComponent {
  constructor() {
    super();
  }
}
